// extracted by mini-css-extract-plugin
export var createdDate = "_i7-1";
export var divider = "_i7-2";
export var headerDivider = "_i7-3";
export var messagesCard = "_i7-0";
export var messagesContainer = "_i7-7";
export var messagesContainerWrapper = "_i7-4";
export var pointerCapturingButtonBoxes = "_i7-a";
export var showLeftPanelButton = "_i7-9";
export var showMoreButton = "_i7-c";
export var showMoreButtonContainer = "_i7-b";
export var summaryTitle = "_i7-6";
export var systemMessageCardWrapper = "_i7-d";
export var topButtons = "_i7-8";
export var withPadding = "_i7-5";